/**
 * Template Interstitial Selectors
 *
 * Memoized selectors for accessing flight interstitial template state.
 * Using createSelector ensures components only re-render when selected data changes.
 *
 * Note: Popup selectors are in popupsSelectors.ts (centralized for all flights templates)
 */
import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/store';

// ============================================
// Base Selectors
// ============================================

const selectTemplateInterstitialState = (state: RootState) => state.flights.templateInterstitial;

// ============================================
// Interstitial Selectors (Memoized)
// ============================================

export const selectSelectedFares = createSelector(
  [selectTemplateInterstitialState],
  (interstitial) => interstitial.selectedFares,
);

export const selectSelectedFareCombo = createSelector(
  [selectTemplateInterstitialState],
  (interstitial) => interstitial.selectedFareCombo,
);

export const selectLoadingFareId = createSelector(
  [selectTemplateInterstitialState],
  (interstitial) => interstitial.loadingFareId,
);

/**
 * Selector for cached interstitial template data.
 * Used when navigating back from traveller page to avoid re-fetching.
 */
export const selectInterstitialTemplateData = createSelector(
  [selectTemplateInterstitialState],
  (interstitial) => interstitial.templateData,
);
